/* eslint-disable no-unused-vars */
import * as Sentry from '@sentry/vue';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithCustomToken, signOut } from 'firebase/auth';
import { parse as parseToken } from '@/utils/token-parser';
import 'flowbite';
import '@/assets/main.css';
import axios from 'axios';
import Notifications from 'notiwind';

import { createApp } from 'vue';
import pinia from '@/stores';

import App from '@/App.vue';
import AppNotAuthenticated from '@/AppNotAuthenticated.vue';

import router from '@/router';
import firebaseConfig from '@/firebase';
import { Authenticate } from './api/customers';
import { useAccountStore } from './stores/account';

const firebaseApp = initializeApp(firebaseConfig);

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const setupAxios = () => {
  axios.interceptors.request.use((req) => {
    const { sessionId } = useAccountStore();
    if (sessionId) {
      req.headers['x-session-id'] = sessionId;
    }
    const { currentUser } = getAuth();
    if (currentUser) {
      const jwt = currentUser.accessToken;
      if (jwt) {
        req.headers.Authorization = `Bearer ${jwt}`;
        req.headers['x-app-id'] = 'STORE_FRONT_APP';
      }
    }
    return req;
  });

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error?.response?.status) {
        const { status } = error.response;
        if (status === 401) {
          // window.location.reload();
          // const auth = getAuth();
          // await signOut(auth);
          // window.location.reload();
        } else if (status === 403) {
          // await router.push({ name: 'Unauthorized' });
        }
      }
      return Promise.reject(error);
    },
  );
};

const init = async () => {
  const auth = getAuth(firebaseApp);
  await signOut(auth);
  const search = new URLSearchParams(window.location.search);
  const sessionToken = search.get('token');
  if (sessionToken) {
    try {
      const {
        sessionId = null,
      } = parseToken(sessionToken);
      const {
        data: {
          data: {
            jwt,
            distributor,
            customer,
          },
        },
      } = await Authenticate(sessionId);
      const credential = await signInWithCustomToken(auth, jwt);
      const accountStore = useAccountStore(pinia);
      accountStore.firebase = credential.user;
      accountStore.data = {
        distributor,
        customer,
      };
      accountStore.sessionId = sessionId;
      accountStore.jwt = sessionToken;
      const app = createApp(App);
      app.use(Notifications);
      app.use(pinia);
      setupAxios();
      app.use(router);
      app.mount('#app');
    } catch (error) {
      const app = createApp(AppNotAuthenticated);
      Sentry.init({
        app,
        dsn: SENTRY_DSN,
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: false,
      });
      app.use(router);
      app.use(pinia);
      app.mount('#app');
      console.log(error);
    }
  } else {
    const app = createApp(App);
    Sentry.init({
      app,
      dsn: SENTRY_DSN,
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: false,
    });
    app.use(Notifications);
    app.use(pinia);
    setupAxios();
    app.use(router);
    app.mount('#app');
  }
  const loader = document.getElementById('loading-overlay');
  if (loader) {
    loader.style.display = 'none';
  }
};

init();
